
export const en = {
  route: {
  },
  view: {
    login: {
    },
    logout: {
    },
    dashboard: {
    },
    partners: {
    },
    contracts: {
    },
    acteAditionale: {
    }
  },
  common: {
  },
  sidebar: {
  },
  navbar: {
  }
}
